export const quizQuestions = [
  {
    id: "question7",
    videoId: "video7",
    topic: "TSMR",
    question: "Broken white line on the road means:",
    options: [
      "You are allowed to overtake on left or right side if there is no danger",
      "It is prohibited to overtake on the left side",
      "It is prohibited to overtake on the right side",
    ],
    correctAnswer:
      "You are allowed to overtake on left or right side if there is no danger",
    descriptionTitle: "Dashed White Line",
    description1:
      "Vehicles driven should always default on the right side of the highway. Suppose that there is a 2-lane road. A driver must maintain to be on the right side opposite of the incoming traffic that will pass on the left side in the perspective of the driver. This image below on the other hand is a 4-lane road. This means that each direction now has 2 lanes each. The other half will be one direction, and the other side will be the opposite direction. On one half of the road, a vehicle that will overtake another vehicle must pass on the left side of the half going in the same direction. This also applies to the other direction.",
  },
];
